import { Component, OnInit, HostBinding, Input, Output, EventEmitter, ViewChild, TemplateRef, ComponentFactoryResolver, Injector, Optional, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { CallActivitySubProcess } from '../call-activity-sub-process/call-activity-sub-process.entity';
import { MessagerService } from '@farris/ui-messager';
import { ProcessDeUtil } from '../../domain/process-de-util';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable } from 'rxjs';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';
import { ComboListComponent } from '@farris/ui-combo-list';
import { FarrisRadioGroupComponent } from '@farris/ui-forms';
import { IRtShowEntity } from '../../views/aif-process-list-help/entity/IRtShowEntity';
import { ProcessListHelpComponent } from '../../views/aif-process-list-help/components/process-list-help/process-list-help.component';
import { NotifyService } from '@farris/ui-notify';
import { BsModalService } from '@farris/ui-modal';
import { SubProcessType } from '../call-activity-sub-process/SubProcessType';
import { BillSourceType } from '../call-activity-sub-process/BillSourceType';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-call-activity-sub-process2',
  templateUrl: './call-activity-sub-process2.component.html',
  providers: [
     WfLocalePipe,
  ]
})
export class CallActivitySubProcess2Component implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @Input() editorParams: {
    bizTypeId?: string
  } = {};

  @Input() set value(v: CallActivitySubProcess) {
    if (v) {
      this.callActivitySubProcess = v;
      // 为子流程类型赋值
      if (this.callActivitySubProcess.calledElement == null || this.callActivitySubProcess.calledElement == "") {
        if (this.callActivitySubProcess.calledBizDefKey == null || this.callActivitySubProcess.calledBizDefKey == "") {
          this.callActivitySubProcess.subProcessType = SubProcessType.Specified;
        } else {
          this.callActivitySubProcess.subProcessType = SubProcessType.Dynamic;
        }
      } else {
        this.callActivitySubProcess.subProcessType = SubProcessType.Specified;
      }
      // 为单据来源类型赋值
      if (this.callActivitySubProcess.inheritBizDataId === true) {
        this.callActivitySubProcess.billSourceType = BillSourceType.InheritParent;
      } else if (this.callActivitySubProcess.inheritBizDataId === false && this.callActivitySubProcess.useAutoCreationData === false) {
        this.callActivitySubProcess.billSourceType = BillSourceType.VariablesExpression;
      } else if (this.callActivitySubProcess.inheritBizDataId === false && this.callActivitySubProcess.useAutoCreationData === true) {
        this.callActivitySubProcess.billSourceType = BillSourceType.AutoCreation;
      }
      this.getProcessDefKey(this.callActivitySubProcess.calledElement);
      this.getFlowForm(this.callActivitySubProcess.calledBizDefKey);
      this.getAifProcessName(this.callActivitySubProcess.aifProcessCode);
    }
  }
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  modalConfig = {
    title: this.localePipe.transform('component.subProcess.subProcessSet'),
    width: 600,
    height: 342,
    showButtons: true
  };

  callActivitySubProcess: CallActivitySubProcess = new CallActivitySubProcess();

  groupIcon = '<i class="f-icon f-icon-lookup"></i>';

  readonly subProcessType = SubProcessType;
  readonly billSourceType = BillSourceType;
  // @ViewChild("comboProcessType")
  // comboProcessType: ComboListComponent;
  // comboProcessTypeIdField = "value";
  // comboProcessTypeValueField = "value";
  // comboProcessTypeTextField = "text";
  // comboProcessTypeData = [
  //   { value: "Specified", text: "指定子流程" },
  //   { value: "Dynamic", text: "动态子流程" },
  // ];

  // @ViewChild("comboBillSource")
  // comboBillSource: ComboListComponent;
  // comboBillSourceIdField = "value";
  // comboBillSourceValueField = "value";
  // comboBillSourceTextField = "text";
  // comboBillSourceData = [
  //   { value: BillSourceType.InheritParent, text: '与父流程相同' },
  //   { value: BillSourceType.AutoCreation, text: '自动生成下游单据' },
  //   { value: BillSourceType.VariablesExpression, text: '变量表达式' },
  // ];

  @ViewChild("radioGroupProcessType")
  radioGroupProcessType: FarrisRadioGroupComponent;
  radioGroupProcessTypeData = [
    { value: "Specified", name: this.localePipe.transform('component.subProcess.specified') },
    { value: "Dynamic", name: this.localePipe.transform('component.subProcess.dynamic') },
  ];

  @ViewChild("radioGroupBillSource")
  radioGroupBillSource: FarrisRadioGroupComponent;
  radioGroupBillSourceData = [
    { value: BillSourceType.InheritParent, name: this.localePipe.transform('component.subProcess.inheritParent') },
    { value: BillSourceType.AutoCreation, name: this.localePipe.transform('component.subProcess.autoCreation') },
    { value: BillSourceType.VariablesExpression, name: this.localePipe.transform('component.subProcess.variablesExpression') },
  ];

  constructor(
    private notify: NotifyService,
    private modalService: BsModalService,
    private message: MessagerService,
    private util: ProcessDeUtil,
    private http: HttpService,
    private designerState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private cfr: ComponentFactoryResolver,
    private inj: Injector,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }


  clickOK() {
    if (this.validator()) {
      const object = { value: this.callActivitySubProcess, parameters: null };
      this.submitModal.emit(object);
    }
  }

  clickCancel() {
    this.closeModal.emit();
  }

  processConfirm(args: any) {
    if (args) {
      this.callActivitySubProcess.calledElement = args.procDefKey;
      this.callActivitySubProcess.calledElementName = args.name;
    }
  }

  processTypeChange(val) {
    console.log(val);
    if (val == SubProcessType.Specified) {
      this.callActivitySubProcess.calledBizDefKey = null;
      this.callActivitySubProcess.calledBizDefName = null;
    } else if (val == SubProcessType.Dynamic) {
      this.callActivitySubProcess.calledElement = null;
      this.callActivitySubProcess.calledElementName = null;
    }
  }

  billSourceChange(val) {
    console.log(val);
    if (val == BillSourceType.InheritParent) {
      this.callActivitySubProcess.inheritBizDataId = true;
      this.callActivitySubProcess.useAutoCreationData = false;
    } else if (val == BillSourceType.AutoCreation) {
      this.callActivitySubProcess.inheritBizDataId = false;
      this.callActivitySubProcess.useAutoCreationData = true;
    } else if (val == BillSourceType.VariablesExpression) {
      this.callActivitySubProcess.inheritBizDataId = false;
      this.callActivitySubProcess.useAutoCreationData = false;
    }
  }

  selectProcess() {
    this.openProcHelp().subscribe(
      (rte: IRtShowEntity) => {
        if (rte == null) {
          this.notify.warning(this.localePipe.transform('component.subProcess.rteNull'));
          return;
        }
        this.callActivitySubProcess.aifProcessCode = rte.code;
        this.callActivitySubProcess.aifProcessName = rte.name;
      }
    );
  }

  clearProcess() {
    this.callActivitySubProcess.aifProcessCode = null;
    this.callActivitySubProcess.aifProcessName = null;
  }

  openProcHelp() {
    const cmpF = this.cfr.resolveComponentFactory(ProcessListHelpComponent);
    const cmpR = cmpF.create(this.inj, []);
    cmpR.instance.editorParams = this.editorParams;
    const modalRef = this.modalService.show(cmpR, {
      title: this.localePipe.transform('component.subProcess.orderProcess'),
      width: 1250,
      height: 500,
      resizable: true,
      buttons: [
        {
          text: this.localePipe.transform('component.subProcess.clickOk'),
          cls: "btn btn-primary",
          handle: (evt) => {
            cmpR.instance.clickOk(evt);
            modalRef.close();
          }
        },
        {
          text: this.localePipe.transform('component.subProcess.clickCancel'),
          cls: "btn btn-secondary",
          handle: (evt) => {
            cmpR.instance.clickCancel(evt);
            modalRef.close();
          }
        }
      ],
      closed: () => {
        modalRef.dialog.destroy();
      }
    });
    cmpR.instance.modalRef = modalRef;

    return cmpR.instance.procEmitter.asObservable();
  }

  clearProcessDef(args: any) {
    this.callActivitySubProcess.calledElement = '';
    this.callActivitySubProcess.calledElementName = '';
  }

  flowFormConfirm(args: any) {
    if (args) {
      this.callActivitySubProcess.calledBizDefKey = args.id;
      this.callActivitySubProcess.calledBizDefName = args.name;
    }
  }
  clearFlowForm(args: any) {
    this.callActivitySubProcess.calledBizDefKey = '';
    this.callActivitySubProcess.calledBizDefName = '';
  }

  setBizDataId() {
    this.showExprHelp();
  }

  private showExprHelp() {
    let context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    if (this.designerState.schemas.length > 0) {
      for (const schema of this.designerState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    context = this.designerState.addContext(context);
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        context.push(variable);
        // this.expr.addContext(variable);
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.addExpressionText(this.callActivitySubProcess.bizDataId);
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.callActivitySubProcess.bizDataId = expressioninfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  valueChange(bool: boolean) {
    if (bool) {
      this.callActivitySubProcess.bizDataId = null;
    }
  }

  private validator(): boolean {
    if (!this.callActivitySubProcess.inheritBizDataId && !this.callActivitySubProcess.useAutoCreationData && !this.callActivitySubProcess.bizDataId) {
      this.message.warning(this.localePipe.transform('component.subProcess.inheritBizDataId'));
      return false;
    }
    return true;
  }

  private getProcessDefKey(key: string) {
    let url = this.util.getProcessDefinitionWebApi();
    if (key) {
      url += `/procDefKey/${key}`;
      this.http.get(url).subscribe((re: any) => {
        this.callActivitySubProcess.calledElementName = re.name;
      });
    }
  }
  private getFlowForm(id: string) {
    let url = this.util.getFlowFormWebApi();
    if (id) {
      url += `/${id}`;
      this.http.get(url).subscribe((re: any) => {
        this.callActivitySubProcess.calledBizDefName = re.name;
      });
    }
  }

  getAifProcessName(code: string) {
    if (code != null && code != "") {
      this.http.request("GET", `/api/runtime/aif/v1.0/rtbillcreationprocess/getname/${code}`, { responseType: 'text' }).subscribe(
        (res: any) => {
          this.callActivitySubProcess.aifProcessName = res;
        },
        (err) => {
          if (err.error && typeof err.error == "string") {
            err.error = JSON.parse(err.error);
          }
          setTimeout(() => {
            //todo 确定异常结构, 目前采用兼容取值方式
            this.message.error(err.error == null ? err.message : (err.error.Message || err.error.message || err.message));
          }, 300);
          throw err;
        });
    }
  }
}


export class CallActivitySubProcess2Converter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data && (data.calledBizDefKey || data.calledElement)) {
      return this.localePipe.transform("component.subProcess.set");
    }
    return this.localePipe.transform("component.subProcess.notSet");
  }
}
